import {
  IDX_LAUNCHLAB_FEES,
  IDX_LAUNCHLAB_PLATFORM_SETTINGS,
} from "@/config/idxLaunchlabLandingConfig";
import { IDX_LAUNCHLAB_REWARDS_PATH } from "@/config/idxLaunchlabAppConfig";
import { IDX_LAUNCHLAB_CPMM_FEE_RATES } from "@/lib/idx-launchlab/platform-on-chain-config";

function formatPercentFromBps(bps) {
  return `${bps / 100}%`;
}

function formatPercentFromRatePerMillion(ratePerMillion) {
  const pct = (ratePerMillion / 1_000_000) * 100;
  const formatted = Number.isInteger(pct) ? String(pct) : pct.toFixed(2).replace(/\.?0+$/, "");
  return `${formatted}%`;
}

function formatLpFeeShareLabel(scale) {
  const pct = (scale / 1_000_000) * 100;
  const formatted = Number.isInteger(pct) ? String(pct) : pct.toFixed(1);
  return `~${formatted}%`;
}

export const IDX_CREATOR_CURVE_RATE_LABEL = formatPercentFromBps(
  IDX_LAUNCHLAB_FEES.creatorBps,
);

export const IDX_CREATOR_POOL_FEE_SHARE_LABEL = formatLpFeeShareLabel(
  IDX_LAUNCHLAB_PLATFORM_SETTINGS.lpSplit.creatorScale,
);

export const IDX_CPMM_CREATOR_FEE_RATE_LABEL = formatPercentFromRatePerMillion(
  IDX_LAUNCHLAB_CPMM_FEE_RATES.creatorRatePerMillion,
);

/** Stage-based creator earnings for IDX Launchlab coins (single source of truth). */
export const IDX_CASHBACK_STAGES = [
  {
    id: "curve",
    stage: "Bonding curve",
    earns: `${IDX_CREATOR_CURVE_RATE_LABEL} per trade`,
    claimVia: "Rewards → curve vault",
  },
  {
    id: "graduated",
    stage: "After graduation",
    earns: `${IDX_CREATOR_POOL_FEE_SHARE_LABEL} LP Fee Key + ${IDX_CPMM_CREATOR_FEE_RATE_LABEL} CPMM (SOL)`,
    claimVia: "Rewards → pool fees",
  },
];

export const IDX_LAUNCHLAB_REWARDS_HREF = IDX_LAUNCHLAB_REWARDS_PATH;
